import { HttpInterceptorFn, HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, throwError } from 'rxjs';
import { ToastrService } from 'ngx-toastr';

/**
 * Modern functional HTTP interceptor for error handling
 * Displays user-friendly error messages
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const toastr = inject(ToastrService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      // Only handle errors not already handled by auth interceptor
      if (error.status !== 401 && error.status !== 403) {
        if (error.status === 500) {
          toastr.error('Internal server error. Please try again later.', 'Error 500');
        } else if (error.status !== 0) { // Skip network errors (handled by auth interceptor)
          toastr.error('An unknown error occurred.', `Error ${error.status}`);
        }
      }

      return throwError(() => error);
    })
  );
};
